import { Auth0Client } from '@auth0/auth0-spa-js';

export const Auth0SdkServiceModule = angular
    .module('app.services.auth.auth0SdkService', [
    ])
    .service('auth0SdkService', (
        $q
    ) => {
        const auth0 = window.crypto ? new Auth0Client({
            domain: process.env.AUTH0_DOMAIN,
            client_id: process.env.AUTH0_CLIENT_ID,
            audience: process.env.AUTH0_AUDIENCE
        }) : null;

        function handleRedirectCallback() {
            let deferred = $q.defer();
            auth0.handleRedirectCallback().then(() => {
                deferred.resolve();
            }).catch((e) => {
                deferred.reject(e);
            });
            return deferred.promise;
        }

        function loginWithRedirect(options) {
            let deferred = $q.defer();
            auth0.loginWithRedirect(options).then(() => {
                deferred.resolve();
            }).catch((e) => {
                deferred.reject(e);
            });
            return deferred.promise;
        }

        function isAuthenticated() {
            let deferred = $q.defer();
            auth0.isAuthenticated().then((authenticated) => {
                deferred.resolve(authenticated);
            }).catch(() => {
                deferred.resolve(false);
            });
            return deferred.promise;
        }

        function getTokenSilently() {
            let deferred = $q.defer();
            auth0.getTokenSilently().then((token) => {
                deferred.resolve(token);
            }).catch(() => {
                deferred.resolve(null);
            });
            return deferred.promise;
        }

        function getUser() {
            let deferred = $q.defer();
            auth0.getUser().then((user) => {
                deferred.resolve(user);
            }).catch(() => {
                deferred.resolve(null);
            });
            return deferred.promise;
        }

        function logout(options) {
            let deferred = $q.defer();
            auth0.logout(options).then(() => {
                deferred.resolve();
            }).catch((e) => {
                deferred.reject(e);
            });
            return deferred.promise;
        }

        return {
            loginWithRedirect,
            isAuthenticated,
            getTokenSilently,
            getUser,
            handleRedirectCallback,
            logout
        };
    })
    .name;



// WEBPACK FOOTER //
// ./src/app/services/auth/auth0sdk.service.js